var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-textarea", {
    attrs: { outlined: "", name: _vm.name, label: _vm.label },
    on: {
      input: function($event) {
        return _vm.$emit("input", _vm.myValue)
      }
    },
    model: {
      value: _vm.myValue,
      callback: function($$v) {
        _vm.myValue = $$v
      },
      expression: "myValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }